import { useEffect } from "react";

// Admin list pages (Bookings, Quote Leads, Contacts) only fetch on mount/filter-change — an admin
// who leaves a tab open sees whatever was true at load time forever, with nothing telling them
// it's gone stale. This keeps them live without a manual reload: refetch when the tab regains
// focus (the common case — switching back to an already-open tab) and on a background interval
// as a backup for a tab left open and focused the whole time.
const useAutoRefresh = (refresh, intervalMs = 30000) => {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refresh);
    const interval = setInterval(refresh, intervalMs);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refresh);
      clearInterval(interval);
    };
  }, [refresh, intervalMs]);
};

export default useAutoRefresh;
